import { Autocomplete, TextField } from '@mui/material';

export const SHIPPER_OPTIONS = ['Smartways', 'Toll', 'TGE', 'DHL', 'ABC', 'Shipped by Medtech', 'Other'];

type Props = {
  value?: string;
  onChange: (value?: string) => void;
  disabled?: boolean;
  required?: boolean;
  label?: string;
};

const ShipperSelect = ({ value, onChange, disabled, required, label = 'Courier' }: Props) => (
  <Autocomplete
    value={value || null}
    options={SHIPPER_OPTIONS}
    disabled={disabled}
    size="small"
    renderInput={params => (
      <TextField
        {...params}
        name="shipper"
        label={label}
        required={required}
        error={Boolean(required) && !disabled && !value}
      />
    )}
    onChange={(_, val) => onChange(val || undefined)}
  />
);

export default ShipperSelect;
